import { DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { GridCellProps } from '@progress/kendo-react-grid';
import GridCellBase from 'src/components/GridCellBase';
import DropDown from 'src/components/design-system/DropDown';
import { DropDownListData } from 'src/types/generic';

const options: DropDownListData = [
  {
    label: 'Subtract',
    value: 'subtract',
  },
  {
    label: 'Add',
    value: 'add',
  },
];

const CardDropdownCell = (props: GridCellProps) => {
  const { dataItem } = props;

  const handleChange = (e: DropDownListChangeEvent) => {
    if (props.onChange) {
      props.onChange({
        dataIndex: props.dataIndex,
        dataItem: props.dataItem,
        field: 'card',
        syntheticEvent: e.syntheticEvent,
        value: e.target.value.value,
      });
    }
  };

  let value = options.find((item) => item?.value === dataItem.card);

  return (
    <GridCellBase {...props} title={value?.label}>
      <DropDown onChange={handleChange} value={value?.value} options={options} />
    </GridCellBase>
  );
};

export default CardDropdownCell;
